import React from 'react';
// ❗ IMPORTANT: You would import your actual SearchHotel component here.
// import SearchHotel from '../../Components/Hotels/SearchHotels';

const HotelSearchPanel1 = () => {
    return (
        <div>
            {/* Tabs for Hotels, Holidays, etc. can be added here if needed */}
            <div className="row g-3">
                <div className="col-md-4">
                    <label className="form-label">CITY OR HOTEL</label>
                    <input type="text" className="form-control form-control-lg" placeholder="e.g., Dubai" />
                </div>
                <div className="col-md-2">
                    <label className="form-label">CHECK-IN</label>
                    <input type="date" className="form-control form-control-lg" />
                </div>
                <div className="col-md-2">
                    <label className="form-label">CHECK-OUT</label>
                    <input type="date" className="form-control form-control-lg" />
                </div>
                <div className="col-md-2">
                    <label className="form-label">ROOMS & GUESTS</label>
                    <input type="text" className="form-control form-control-lg" placeholder="1 Room, 2 Adults" />
                </div>
                <div className="col-md-2 d-flex align-items-end">
                    <button className="btn btn-primary btn-lg w-100">SEARCH</button>
                </div>
            </div>
             <p className="text-start mt-3 text-muted">Trending cities: London, New York, Tokyo</p>
        </div>
    );
};

export default HotelSearchPanel1;